export default function useZendeskWebWiget() {
    const { zE } = window;

    function updateSettings(settings: ZendeskSettings['webWidget']) {
        if (zE) {
            zE('webWidget', 'updateSettings', { webWidget: settings });
        }
    }

    return {
        updateSettings,
    };
}
